import { FiCheck, FiX } from "react-icons/fi";
import {
  MODEL_CATEGORY_OPTIONS,
  MODEL_TYPE_OPTIONS,
  MODEL_TYPE_UNITS,
  ModelType,
  OTHER_ITEM_OPTIONS,
  hasModelCategorySelection,
  parseModelTypes,
  persistModelTypes,
} from "../../utils/jobCard";

export type UnitsModelValue = {
  model: "Yes" | "No";
  modelTypes: string[];
  modelBy: string;
};

const UnitsModelEditor = ({
  value,
  onChange,
}: {
  value: UnitsModelValue;
  onChange?: (next: UnitsModelValue) => void;
}) => {
  const types = parseModelTypes(value.modelTypes);
  const editable = Boolean(onChange);

  const toggleType = (nextType: ModelType) => {
    if (!onChange) return;
    const nextSelected = types.includes(nextType)
      ? types.filter((type) => type !== nextType)
      : [...types, nextType];
    const modelYes = hasModelCategorySelection(nextSelected);
    onChange({
      model: modelYes ? "Yes" : "No",
      modelTypes: persistModelTypes(modelYes, nextSelected),
      modelBy: modelYes ? value.modelBy : "",
    });
  };

  const renderOption = (option: (typeof MODEL_TYPE_OPTIONS)[number]) => {
    const selected = types.includes(option.value);
    const rowClass = `flex min-w-0 items-center justify-between gap-1.5 rounded-xl px-1.5 py-0.5 text-[13px] ${
      selected ? "text-[#4A4A48]" : "text-[#8A8A85]"
    } ${
      editable
        ? "cursor-pointer hover:bg-[#F8F8F6]"
        : "cursor-default"
    }`;
    const icon = selected ? (
      <FiCheck
        className="h-3.5 w-3.5 shrink-0 text-emerald-600"
        aria-hidden
      />
    ) : (
      <FiX className="h-3.5 w-3.5 shrink-0 text-rose-500" aria-hidden />
    );

    if (!editable) {
      return (
        <div key={option.value} className={rowClass}>
          <span className="truncate">
            {option.label}
            <span className="ml-1 text-[11px] text-[#8A8A85]">
              {MODEL_TYPE_UNITS[option.value]}u
            </span>
          </span>
          {icon}
        </div>
      );
    }

    return (
      <button
        key={option.value}
        type="button"
        onClick={() => toggleType(option.value)}
        aria-pressed={selected}
        title={selected ? `Unmark ${option.label}` : `Mark ${option.label}`}
        className={rowClass}
      >
        <span className="truncate">
          {option.label}
          <span className="ml-1 text-[11px] text-[#8A8A85]">
            {MODEL_TYPE_UNITS[option.value]}u
          </span>
        </span>
        {icon}
      </button>
    );
  };

  return (
    <div className="flex flex-col gap-0.5">
      {MODEL_CATEGORY_OPTIONS.map(renderOption)}
      <div className="my-0.5 border-t border-[#E8E8E4]" />
      {OTHER_ITEM_OPTIONS.map(renderOption)}
    </div>
  );
};

export default UnitsModelEditor;
